import { render, staticRenderFns } from "./CoordinatesSettings.vue?vue&type=template&id=f7d334e4&scoped=true"
import script from "./CoordinatesSettings.vue?vue&type=script&lang=js"
export * from "./CoordinatesSettings.vue?vue&type=script&lang=js"
import style0 from "./CoordinatesSettings.vue?vue&type=style&index=0&id=f7d334e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d334e4",
  null
  
)

export default component.exports